import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FormClientBase } from './form-client-base';
import { ICustomWindow, WindowRefService } from '../../_shared/services/window-ref.service';

export class FormClientSalesforce extends FormClientBase {
    protected get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    constructor(httpClient: HttpClient, private _windowRef: WindowRefService) {
        super(httpClient);
    }

    submit(): void {
        if (!this._submission.recaptchaToken) {
            console.error('reCaptcha token is empty');

            return;
        }

        this._isSubmitting.next(true);

        if (this.Window && !this._submission.apiUrl) {
            this._submission.apiUrl = this.Window.location.href;
        }

        const fields = this._submission.data.fields;
        const formData = new FormData();

        Object.keys(fields).forEach((key) => formData.set(key, fields[key]));
        formData.set('g-recaptcha-response', this._submission.recaptchaToken);

        this._httpClient
            .post(this._submission.apiUrl, formData, { responseType: 'text' })
            .subscribe({
                next: (value: string) => this.handleResult(value),
                error: (err: HttpErrorResponse) => this.handleError(err),
            })
            .add(() => {
                this._isSubmitting.next(false);
            });
    }

    private handleResult(res: string): void {
        if (res.includes('#FORM-RESPONSE-SUCESS#')) {
            this._success.next({ type: 'success', message: res });
        }

        if (res.includes('#FORM-RESPONSE-ERROR#')) {
            this._error.next({ type: 'error', message: res });

            return;
        }

        this._complete.next();
    }
}
